<app-header #header></app-header>
<ng-container *ngIf="tracking$ | async"></ng-container>
<ion-content
  *ngIf="homePageViewModel$ | async as viewModel"
  id="home"
  class="gray-content-bg"
  [scrollEvents]="true"
  (ionScrollStart)="onScrollStart()"
  (ionScrollEnd)="onScrollEnd()"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
>
  <!-- MY ORDERS TEMPLATE -->
  <ng-template #myOrders>
    <ng-container *ngIf="recentOrderVM$ | async as recentOrderViewModel">
      <app-recent-order-tile
        [recentOrderViewModel]="recentOrderViewModel"
        [platformService]="platformService"
        (handleRecentOrderButtonClick)="handleRecentOrderButtonClick(recentOrderViewModel)"
        (viewMyOrdersClick)="routeTo(PATHS.MY_ORDERS_VIEW)"
        (createNewOrderClick)="createNewOrder(recentOrderViewModel)"
      ></app-recent-order-tile>
    </ng-container>
  </ng-template>

  <!-- CUSTOM MESSAGE TEMPLATE -->
  <ng-template #customMessageBanner>
    <app-custom-message-banner
      [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
      [customMessageBannerInfo]="viewModel?.customMessage"
    ></app-custom-message-banner>
  </ng-template>

  <!-- HOME BANNER -->
  <div
    data-cy="home-page-banner-section"
    class="home-banner"
    [ngClass]="viewModel?.customMessage ? 'has-custom-message-banner' : ''"
  >
    <ion-grid [fixed]="true">
      <!-- DESKTOP -->
      <div *ngIf="(platformService?.isTouchExperience$ | async) === false">
        <ion-row>
          <!-- HELPING YOU MAKE IT -->
          <ion-col size-xl="4" size-lg="5" size-md="5.5">
            <div
              data-cy="home-page-banner-text-section"
              class="home-banner-text"
            >
              <span data-cy="home-page-banner-text">
                {{ 'i18n.home.helpingYouMakeIt' | translate }}
                <sup class="registered-mark">&reg;</sup>
              </span>
            </div>
          </ion-col>
          <!-- MY ORDERS -->
          <ion-col size-xl="8" size-lg="7" size-md="6.5">
            <ng-container [ngTemplateOutlet]="myOrders"></ng-container>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="viewModel?.customMessageFlag && viewModel?.customMessage"
          data-cy="home-page-custom-message-banner"
        >
          <ng-container [ngTemplateOutlet]="customMessageBanner"></ng-container>
        </ion-row>
      </div>

      <!-- TOUCH -->
      <div *ngIf="(platformService?.isTouchExperience$ | async)">
        <ion-row class="ion-justify-content-between">
          <!-- HELPING YOU MAKE IT -->
          <ion-col size-lg="6" size-md="6" size-sm="12" size-xs="12">
            <div
              data-cy="home-page-banner-text-section"
              class="home-banner-text"
            >
              <span data-cy="home-page-banner-text">
                {{ 'i18n.home.helpingYouMakeIt' | translate }}
                <sup class="registered-mark">&reg;</sup>
              </span>
            </div>
          </ion-col>
          <!-- MY ORDERS (TABLET) -->
          <ion-col
            *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
            size-lg="6"
            size-md="6"
          >
            <ng-container [ngTemplateOutlet]="myOrders"></ng-container>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet && viewModel?.customMessageFlag && viewModel?.customMessage"
          data-cy="home-page-custom-message-banner"
        >
          <ng-container [ngTemplateOutlet]="customMessageBanner"></ng-container>
        </ion-row>
      </div>
    </ion-grid>
  </div>

  <!-- HOME CONTENT-->
  <div class="home-content">
    <div
      *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
    >
      <ng-container
        *ngIf="viewModel?.customMessageFlag && viewModel?.customMessage"
        data-cy="home-page-custom-message-banner"
        [ngTemplateOutlet]="customMessageBanner"
      >
      </ng-container>
      <!-- MY ORDERS (MOBILE) -->
      <ng-container [ngTemplateOutlet]="myOrders"></ng-container>
    </div>

    <!-- HOME OPTIONS -->
    <div class="home-options">
      <ng-container *ngIf="incentivePrograms$ | async as incentivePrograms">
        <app-rebates-banner
          *appShowSplit="[rebatesBannerFlag]"
          [incentivePrograms]="incentivePrograms"
        ></app-rebates-banner>
      </ng-container>
      <app-tiles-container
        [deliveryTime]="viewModel?.deliveryDetails"
        [listsData]="viewModel?.listsDataForHomePage"
        [dealsFlag]="viewModel?.dealsFlag"
        [newsFlag]="viewModel?.newsFlag"
        [betterBuysFlag]="viewModel?.betterBuysFlag"
        [newsPageData]="viewModel?.newsPageData"
        [recommendedDetails]="viewModel?.recommendedDetails"
        [customerTimeZone]="this.selectedCustomer?.timeZone"
        [totalAnnualSavings]="viewModel?.totalAnnualSavings"
        [searchPath]="viewModel?.searchPath"
      >
      </app-tiles-container>
    </div>
    <ng-container *ngIf="userHasAvendraForGoodCustomization">
      <ion-card
        data-cy="avendra-for-good-banner"
        *appShowSplit="[avendraForGoodBanner]"
        class="clickable-banner"
        (click)="routeTo(PATHS.SEARCH, {searchText: 'avendraforgood'})"
      >
        <img
          *ngIf="(platformService?.isTouchExperience$ | async) === false"
          data-cy="avendra-for-good-banner-img-desktop"
          alt=""
          src="assets/images/home-avendra-for-good-banner-desktop.webp"
        />
        <img
          *ngIf="(platformService?.isTouchExperience$ | async) && platformService?.platformType !== platformService?.platformEnum?.mobile"
          data-cy="avendra-for-good-banner-img-tablet"
          alt=""
          src="assets/images/home-avendra-for-good-banner-tablet.webp"
        />
        <img
          *ngIf="(platformService?.isTouchExperience$ | async) &&
        platformService?.platformType === platformService?.platformEnum?.mobile"
          data-cy="avendra-for-good-banner-img-mobile"
          alt=""
          src="assets/images/home-avendra-for-good-banner-mobile.webp"
        />
      </ion-card>
    </ng-container>
    <ng-container *ngIf="isInternalUser$ | async">
      <ion-card
        *appShowSplit="[scoopPreviewBannerFlag]"
        data-cy="scoop-preview-banner"
        class="clickable-banner"
        (click)="handleScoopPreviewBannerClick()"
      >
        <img
          *ngIf="platformService?.platformType !== platformService?.platformEnum?.mobile"
          data-cy="scoop-preview-banner-image"
          src="assets/images/scoop-spring-preview-banner.webp"
        />
        <img
          *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
          data-cy="scoop-preview-banner-image-mobile"
          src="assets/images/scoop-spring-preview-banner-mobile.webp"
        />
      </ion-card>
    </ng-container>
    <ng-container
      *ngIf="(recentlyViewedProducts$ | async) as recentlyViewedProducts"
    >
      <ng-container
        *ngIf="recentlyViewedFeatureFlag && recentlyViewedProducts.length > 0"
      >
        <app-merchandising-product-carousel
          [products]="recentlyViewedProducts"
          [platformType]="platformService?.platformType"
          [title]="'i18n.home.recentlyViewed' | translate"
          [linkSource]="recentlyViewedLnkSrc"
          [merchFeature]="RECENTLY_VIEWED_FEATURE_NAME"
          [addMethod]="RECENTLY_VIEWED_FEATURE_NAME"
          (quantityUpdateEmitter)="onQuantityUpdate($event.quantityUpdate, $event.index)"
        ></app-merchandising-product-carousel>
      </ng-container>
    </ng-container>

    <div
      #interactBannerContainer
      *ngIf="this.isInteractBannersFeatureFlagEnabled"
      data-cy="home-page-interact-banners"
      class="interact-banners"
    >
      <app-interact-banner
        *ngFor="let interactBanner of interactBanners; let i = index"
        [interactBannerInfo]="interactBanner"
        [isNewSearchEnabled]="viewModel.searchPath === PATHS.NEW_SEARCH"
      ></app-interact-banner>
    </div>
    <div
      *ngIf="!this.isInteractBannersFeatureFlagEnabled"
      data-cy="home-page-scoop-button"
      class="home-scoop"
      (click)="routeTo(PATHS.SEARCH, {searchFilterProperties: newScoopProducts })"
    ></div>
  </div>
  <app-footer></app-footer>
</ion-content>

<!-- Floating Tooltip for Home -->
<div data-cy="home-page-help-section" class="help-icon">
  <img
    data-cy="home-page-open-help-modal-button"
    src="assets/icon/custom-help-tooltip.svg"
    (click)="openHelpModal()"
  />
</div>
